$(function () {
    function escHtml(s) {
        if (s == null) {
            return '';
        }
        return $('<div>').text(s).html();
    }

    function initHeroProductCount() {
        var $el = $('#heroProductCount');
        if (!$el.length) {
            return;
        }

        $.ajax({
            url: '/api/products/marketplace',
            method: 'GET',
            data: { limit: 1 },
            dataType: 'json'
        })
        .done(function (data) {
            if (data && data.success && typeof data.total === 'number') {
                $el.text(data.total.toLocaleString());
            }
        })
        .fail(function () {});
    }

    function initTrendingCategories() {
        var $row = $('#trendingCategoriesRow');
        if (!$row.length) {
            return;
        }

        $.ajax({
            url: '/api/productCategories/trending',
            method: 'GET',
            data: { limit: 8 },
            dataType: 'json'
        })
        .done(function (data) {
            if (!data || !data.success || !Array.isArray(data.categories)) {
                $row.html(
                    '<div class="col-12 text-center py-4 text-muted">No categories available</div>'
                );
                return;
            }

            var categories = data.categories;
            if (categories.length === 0) {
                $row.html(
                    '<div class="col-12 text-center py-4 text-muted">No categories with products yet</div>'
                );
                return;
            }

            var html = '';
            categories.forEach(function (cat) {
                var id = cat.id != null ? String(cat.id) : '';
                var name = escHtml(cat.name || '');
                var count =
                    cat.product_count != null && cat.product_count > 0
                        ? ' <span class="text-muted small">(' +
                            Number(cat.product_count).toLocaleString() +
                            ')</span>'
                        : '';
                html +=
                    '<div class="col-md-6 col-lg-3">' +
                    '<a href="/marketplace?category=' +
                    encodeURIComponent(id) +
                    '" class="category-box d-flex align-items-center p-3 text-decoration-none h-100">' +
                    '<i class="fa-solid fa-tag fa-2x text-primary me-3"></i>' +
                    '<span class="fw-semibold text-dark">' +
                    name +
                    count +
                    '</span>' +
                    '</a></div>';
            });
            $row.html(html);
        })
        .fail(function () {
            $row.html(
                '<div class="col-12 text-center py-4 text-muted">Could not load categories</div>'
            );
        });
    }

    function initHomeNews() {
        var $row = $('#homeNewsRow');
        if (!$row.length) {
            return;
        }

        $.ajax({
            url: '/api/newsPosts/recent',
            method: 'GET',
            data: { limit: 5 },
            dataType: 'json'
        })
        .done(function (data) {
            if (!data || !data.success || !Array.isArray(data.posts)) {
                $row.html('<div class="col-12 text-center py-4 text-muted">No news yet</div>');
                return;
            }

            var posts = data.posts;
            if (posts.length === 0) {
                $row.html('<div class="col-12 text-center py-4 text-muted">No news yet</div>');
                return;
            }

            var fallback = '/assets/img/company/not_available.webp';

            function fmtDate(iso) {
                if (!iso) {
                    return '';
                }
                var dt = new Date(String(iso).replace(' ', 'T'));
                if (isNaN(dt.getTime())) {
                    return escHtml(String(iso));
                }
                return escHtml(
                    dt.toLocaleDateString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    })
                );
            }

            var html = '';
            posts.forEach(function (p) {
                var title = p.title != null ? String(p.title) : '';
                var slug = p.slug != null ? String(p.slug) : '';
                var excerpt = p.excerpt != null ? String(p.excerpt).trim() : '';
                var img = p.featured_image_url ? String(p.featured_image_url) : fallback;
                html +=
                    '<div class="col-md-6 col-lg-3">' +
                    '<div class="card border-0 shadow-sm h-100">' +
                    '<a href="/news/' +
                    encodeURIComponent(slug) +
                    '" class="text-decoration-none">' +
                    '<img src="' +
                    escHtml(img) +
                    '" class="card-img-top" alt="' +
                    escHtml(title) +
                    '" style="height: 220px; object-fit: cover;" loading="lazy">' +
                    '</a>' +
                    '<div class="card-body d-flex flex-column">' +
                    '<small class="text-muted d-block mb-2"><i class="fa fa-calendar me-1"></i> ' +
                    fmtDate(p.published_at) +
                    '</small>' +
                    '<h5 class="fw-semibold"><a href="/news/' +
                    encodeURIComponent(slug) +
                    '" class="text-dark text-decoration-none">' +
                    escHtml(title) +
                    '</a></h5>' +
                    '<p class="text-muted small mb-3 flex-grow-1">' +
                    (excerpt
                        ? escHtml(
                                excerpt.length > 120 ? excerpt.substring(0, 120) + '…' : excerpt
                            )
                        : '') +
                    '</p>' +
                    '<a href="/news/' +
                    encodeURIComponent(slug) +
                    '" class="text-primary fw-semibold text-decoration-none mt-auto">Read more <i class="fa fa-arrow-right ms-1"></i></a>' +
                    '</div></div></div>';
            });
            $row.html(html);
        })
        .fail(function () {
            $row.html(
                '<div class="col-12 text-center py-4 text-muted">Could not load news</div>'
            );
        });
    }

    initHeroProductCount();
    initTrendingCategories();
    initHomeNews();
});